import React, { useState } from 'react'
import EnquiryCard from './EnquiryCard';
import EnquiryTable from './EnquiryTable';

const Enquiry = () => {
    //#region code
    const [isChanged, setIsChanged] = useState(false);
    const [editData, setEditData] = useState(null);

    const handleChange = () => {
        setIsChanged(!isChanged);
    }

    const handleEdit = (params) => {
        setEditData(params)
    }

    //#endregion

    return (
        <>
            <EnquiryCard isChanged={handleChange} editData={editData} setEditData={setEditData} />
            <EnquiryTable isChanged={isChanged} handleEdit={handleEdit} />
        </>
    )
}

export default Enquiry;
